// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"4cc72946","64":"55e7afde","207":"24fd5f04","328":"9a8a2984","361":"370cc672","363":"4a4260a6","484":"76cac624","640":"a9755993","678":"52673835","922":"db135369"}[chunkId] + ".chunk.js";
};